const { theme } = require('../theme');

const breakpointService = {
  cache: {},

  getCurrentBreakpoint: () => {
    if (typeof document === 'undefined') {
      return breakpointService.getSmallestBreakpoint();
    }

    return breakpointService.searchBreakpoint(
      document.documentElement.clientWidth
    );
  },

  searchBreakpoint: width => {
    if (breakpointService.cache[width]) {
      return breakpointService.cache[width];
    }
    let currentBreakpoint = theme.breakpoints.sorted.find(
      breakpoint => width < breakpoint.width
    );

    // It's undefined when width is bigger that the largest breakpoint,
    // so let's use that largest one as a fallback.
    if (!currentBreakpoint) {
      currentBreakpoint = breakpointService.getLargestBreakpoint();
    }

    breakpointService.cache[width] = currentBreakpoint;
    return currentBreakpoint;
  },

  getNextBreakpoint: breakpoint =>
    theme.breakpoints.sorted[breakpoint.index + 1],

  getMobileBreakpoint: () => theme.breakpoints.byName.mobile,

  getTabletBreakpoint: () => theme.breakpoints.byName.tablet,

  getSmallDesktopBreakpoint: () => theme.breakpoints.byName.small_desktop,

  getLargeDesktopBreakpoint: () => theme.breakpoints.byName.large_desktop,

  isMobile: () => breakpointService.getCurrentBreakpoint().name === 'mobile',

  isTablet: () => breakpointService.getCurrentBreakpoint().name === 'tablet',

  isSmallDesktop: () =>
    breakpointService.getCurrentBreakpoint().name === 'small_desktop',

  isLargeDesktop: () =>
    breakpointService.getCurrentBreakpoint().name === 'large_desktop',

  isHandheld: () =>
    breakpointService.isMobile() || breakpointService.isTablet(),

  isDesktop: () =>
    breakpointService.isSmallDesktop() || breakpointService.isLargeDesktop(),

  getSmallestBreakpoint: () => theme.breakpoints.sorted[0],

  getLargestBreakpoint: () =>
    theme.breakpoints.sorted[theme.breakpoints.sorted.length - 1]
};

module.exports = { breakpointService };
